<template>
    <div class="pdf-box">
        <template v-if="code=='b06'">
            <div class="item">
                <div class="head">
                    <div>
                        工程材料、构配件、设备报审表
                    </div>
                    <div>
                        <div>
                            工程名称：
                            {{vuex_admin.pro.title}}
                        </div>
                        <div>
                            编号：001
                        </div>
                    </div>
                </div>
                <div class="box2">
                    <div>
                        致：
                        <span class="i">
                            {{vuex_admin.pro.jl}}
                        </span>
                        （项目监理机构）
                    </div>
                    <div>
                        于{{info.data.date_in}}进场的拟用于工程
                        <span class="i">
                            {{_douh_arr(info.datas,'title')}}
                        </span>
                        部位
                        <span class="i">
                            {{_douh_arr(info.datas,'title')}}
                        </span>
                        的
                        ，经我方检验合格，现将相关资料报上，请予以审查。
                        <div>
                            请予以审核。
                        </div>
                    </div>
                    <div>
                        附件：
                        <div>
                            1. 工程材料、构配件或设备清单
                            2. 质量证明文件
                            3. 自检结果
                        </div>
                    </div>
                    <div class="flex">
                        <div>
                            分包项目经理部（盖章）
                            分包项目经理（签字）
                        </div>
                        <div class="flex-1"></div>
                        <div>
                            施工项目经理部（盖章）
                            项目经理（签字）
                        </div>
                    </div>
                </div>
                <div class="box3">
                    审查意见：
                    <div>
                        项目监理机构（盖章）
                        专业监理工程师（签字）
                        <div>
                            年 月 日
                        </div>
                    </div>
                </div>
                <div class="foot">
                    注：本表一式二份，项目监理机构、施工单位各一份。
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    export default {
        props: {
            table: {},
            code: {}
        },
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
        }
    }
</script>
<style lang="scss" scoped>
    @import "index.scss";
</style>